/**
 * appBadge — iter87.243. Wraps the Web Badging API for the installed
 * Rivalry Pro+ home-screen app (iOS Safari 16.4+ only; Android Chrome
 * has no `setAppBadge` support, so this silently no-ops there).
 *
 * iter87.243 (bug fix) — iOS ties badge VISIBILITY to Notification
 * permission even though no push notification is ever sent: WebKit's
 * own badging blog is explicit that `setAppBadge()` resolves fine but
 * the OS won't render the badge until the installed app has been
 * granted notification permission. `syncAppBadge` now requests that
 * permission (once, on first call) before setting the badge, and
 * skips setting it entirely if the user denies.
 */
export async function syncAppBadge(count) {
    if (!("setAppBadge" in navigator)) return;
    try {
        if (typeof Notification !== "undefined" && Notification.permission === "default") {
            await Notification.requestPermission();
        }
        if (typeof Notification !== "undefined" && Notification.permission !== "granted") return;
    } catch {
        return;
    }
    if (count > 0) {
        navigator.setAppBadge(count).catch(() => {});
    } else {
        navigator.clearAppBadge().catch(() => {});
    }
}

export function totalTodoCount(todosByLeague) {
    return Object.values(todosByLeague || {}).reduce(
        (sum, t) => sum + (t?.player?.length || 0) + (t?.admin?.length || 0),
        0,
    );
}
